// extracted by mini-css-extract-plugin
export default {"root":"NumPad_root__UxT52","num":"NumPad_num__vlfPg","buttons":"NumPad_buttons__FPFPW","button":"NumPad_button__ZYZUt"};